import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import MUIDataTable from "mui-datatables";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import EmojiEventIcon from "@material-ui/icons/EmojiEvents";
import {LinearProgress} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
    },
    table: {
        minWidth: "80vh",
    },
}));

export default function PlaylistList(props) {

    const columns = [
        {
            label: 'Moment Playlist ID',
            name: "id"
        },
        {
            label: 'Moment Playlist Title',
            name: "title"
        },
        {
            label: 'Actions',
            name: "actions",
            options: {
                filter: false,
                download: false,
                customBodyRender: (value, tableMeta, updateValue) => {

                    return (
                        <Grid container spacing={0} direction="row" justify="space-evenly" alignItems={"center"}>

                                <Button item xs={6} variant="contained" onClick={props.handleEdit.bind(this, tableMeta.rowData[0])}
                                        color="primary" className={classes.button}>
                                    Edit
                                </Button>

                                <Tooltip item xs={6}  title="Delete Moments Playlist" aria-label="Delete Moments Playlist">
                                    <IconButton  aria-label="delete"
                                                onClick={props.deletePlaylist.bind(this, tableMeta.rowData[0])}
                                                className={classes.button}>
                                        <DeleteIcon fontSize="small"/>
                                    </IconButton>
                                </Tooltip>
                        </Grid>
                    );

                }
            }
        },

    ];


    let momentsPlaylists = props.momentsPlaylists;

    const classes = useStyles();

    const options = {
        filterType: 'textField',
        pagination: true,
        selectableRows: 'none',
        print: false,
        viewColumns: false,
        responsive: 'stacked',
        customToolbar: function (columnMeta) {
            let toolBar = (
                <>
                <Button aria-label="Create" variant="contained" color='primary' onClick={props.handleCreate.bind(this)}
                        className={classes.button}>
                    Create New Playlist
                </Button>
                {/*<IconButton aria-label="rewards">*/}
                {/*    <EmojiEventIcon fontSize={"large"} onClick={props.openCompetition.bind(this)} color={"primary"}/>*/}
                {/*</IconButton>*/}
                    </>);
            return toolBar
        }
    };

    return (
        <>
        {momentsPlaylists &&
            <MUIDataTable
                title={"Moments Playlists"}
                data={momentsPlaylists}
                columns={columns}
                options={options}
            />
        }
        {!(momentsPlaylists) &&
            <LinearProgress/>
        }
        </>
    )
}